import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { colors } from "@/theme/colors";

// キャンセル料の固定 3 段 (ゲスト予約・決済_詳細設計 §7.4)。PoC では商品マスタの cancel_policy
// ではなくこの固定ポリシーを正とするため、料率は言語非依存の値としてコードに持つ
// (backend の domain.CalculateRefundPolicy と 1:1。メールは同じ 3 段を返金率で表示する)。
const CANCEL_POLICY_TIERS = [
  { timingKey: "buyerInfo.cancelPolicyUntil2DaysBefore", feePercent: 0 },
  { timingKey: "buyerInfo.cancelPolicyPreviousDay", feePercent: 50 },
  { timingKey: "buyerInfo.cancelPolicySameDay", feePercent: 100 },
] as const;

/**
 * キャンセルポリシー表示 (固定 3 段の表 + 日本時間の注記)。購入者情報入力画面・予約完了画面・
 * 予約キャンセル確認/完了画面で同じ内容を表示する (JPTP_CANSEI-1477 / -1396)。
 *
 * 実際に請求されるキャンセル料は固定 3 段 (§7.4) で算出されるため、商品マスタ由来の
 * cancel_policies は参照しない。
 */
export function CancelPolicySection() {
  const { t } = useTranslation();

  return (
    <Box>
      <Divider sx={{ my: 1.5 }} />
      <Typography sx={{ color: colors.textMuted, fontSize: 14, fontWeight: 600, mb: 1 }}>
        {t("buyerInfo.cancellationPolicy")}
      </Typography>
      <Table
        size="small"
        sx={{
          "& th": { color: colors.textMuted, fontSize: 13, fontWeight: 600 },
          "& td": { color: colors.textBody, fontSize: 15 },
          "& td, & th": { borderColor: colors.border, py: 1 },
          "& tbody tr:last-of-type td": { borderBottom: 0 },
        }}
      >
        <TableHead sx={{ bgcolor: colors.surfaceMuted }}>
          <TableRow>
            <TableCell>{t("buyerInfo.cancelPolicyTimingHeader")}</TableCell>
            <TableCell align="right">{t("buyerInfo.cancelPolicyFeeHeader")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {CANCEL_POLICY_TIERS.map((tier) => (
            <TableRow key={tier.timingKey}>
              <TableCell>{t(tier.timingKey)}</TableCell>
              <TableCell align="right">{`${tier.feePercent}%`}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Typography sx={{ color: colors.textMuted, fontSize: 12, mt: 1 }}>
        {t("buyerInfo.cancelPolicyJstNote")}
      </Typography>
    </Box>
  );
}
